import { atom } from 'recoil';

let filter = atom<any>({
  key: 'filter',
  default: {
    limit: 0,
    interest: 20,
  },
});

export { filter };
